import { render, staticRenderFns } from "./MFAVerification.vue?vue&type=template&id=c522dbda&scoped=true&"
import script from "./MFAVerification.vue?vue&type=script&lang=js&"
export * from "./MFAVerification.vue?vue&type=script&lang=js&"
import style0 from "./MFAVerification.vue?vue&type=style&index=0&id=c522dbda&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522dbda",
  null
  
)

export default component.exports